module.exports = __webpack_public_path__ + "img/my-dossiers.088a6b83.svg";